<template>
    <div class="main-wrap">
        <Title :title="title" />
        <Classify v-model:active="classifyActive" :data="classify" :label-key="labelKey" @change="changeClassify" />
        <!-- <el-button class="link" type="primary" link @click="goSquare" v-if="classify.length">更多＞</el-button> -->
        <ColumnList class="project-list" :data="list" column="3" gap="24px" v-if="list.length">
            <template #default="{ item }">
                <Card direction="column" :image="item.projectLogo" :title="item.projectName"
                    :tag="projectTypeName(item)" @click="goMatch(item)">
                    <template #label-text>
                        <el-icon class="icon">
                            <Clock />
                        </el-icon>
                        <span class="ellipsis">开始时间：{{ dayjs(item.startTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                    </template>
                </Card>
            </template>
        </ColumnList>
        <NoData info="抱歉，内容正在更新中，请稍后~" url="no-item.png" v-else />
    </div>
    <CodeDialog @on-close="onClose" @on-confirm="onConfirm" :visible="codeVisible" :project-detail="activeItem" />
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { Clock } from '@element-plus/icons-vue'
import { jumpHref } from '@/router/jumpHref.js'
import { pageJump } from '@/global/location-transfer'
import Card from '@/views/scientific-research/components/card.vue'
import Title from '@/views/scientific-research/components/title.vue'
import Classify from '@/views/scientific-research/components/classify.vue'
import ColumnList from '@/views/shenzhen/components/column-list.vue'
import NoData from '@/components/no-data.vue'
import dayjs from 'dayjs'
import CodeDialog from '@/views/shenzhen/components/code-dialog.vue';

const props = defineProps({
    title: {
        type: [String, Number],
        default: '',
    },
})

onMounted(init)

// 初始化
const loaded = ref(true)
async function init () {
    loaded.value = true
    await Promise.allSettled([getClassify()])
    await changeClassify()
    loaded.value = false
}

// 获取分类
const labelKey = 'name'
const classify = ref([])
async function getClassify () {
    try {
        const res = await G_transmit('escHomeGetProjectType', {})
        classify.value = [{ [labelKey]: '全部' }].concat(res?.data || [])
    } catch (error) {
        classify.value = []
    }
}

// 分类选择
const classifyActive = ref()
const classifyValues = computed(() => classify.value?.[classifyActive.value])
async function changeClassify (index) {
    classifyActive.value = index || 0
    await getDataList()
}

// 获取数据列表
const list = ref([])
const projectType = computed(() => classifyValues.value?.code)
async function getDataList () {
    try {
        const queries = { projectType: projectType.value, size: 6 }
        const res = await G_transmit('escHomeProjectItem', { queries })
        list.value = res?.data || []
    } catch (error) {
        list.value = []
    }
}

function projectTypeName (item) {
    const code = item?.projectTypeJson?.code
    const name = item?.projectTypeJson?.name
    return name || classify.value?.find?.(v => upPerCaseFirstLetter(v?.code) == code)?.name || ''
}

function upPerCaseFirstLetter (str = '', uni = '_') {
    return str?.split?.(uni)?.reduce?.((value, str, index) => {
        if (index > 0) str = str?.slice?.(0, 1)?.toUpperCase?.() + str?.slice?.(1)
        return value + str || ''
    }, '')
}

// function goMatch(item) {
//     if (item?.eventsId) {
//         if (item?.stageJson?.code >= 50) pageJump({ name: 'scientificResearchProjectGroup', query: { id: item?.id, name: item?.projectName } }, true)
//         else pageJump(jumpHref.rating2.matchRatingDetail(item?.eventsId, { projectType: item?.projectTypeJson?.code }), true)
//     } else G_dispatchEvent('toast', { message: '申报暂未开始', type: 'info' })
// }

const codeVisible = ref(false)

const activeItem = ref({})

function goMatch (item) {
    activeItem.value = item

    if (item?.eventsId) {
        // 有赛事id则判断是否需要邀请码
        G_transmit('isSetInvite', {
            name: 'isSetInvite',
            queries: {
                projectId: item.id,
            },
        }).then(res => {
            if (res.data === true) {
                codeVisible.value = true;
            } else {
                // 不需要进行跳转
                if (item?.stageJson?.code >= 50) pageJump({ name: 'scientificResearchProjectGroup', query: { id: item?.id, name: item?.projectName } }, true)
                else pageJump(jumpHref.rating2.matchRatingDetail(item?.eventsId, { projectType: item?.projectTypeJson?.code }), true)
            }
        });

    } else G_dispatchEvent('toast', { message: '申报暂未开始', type: 'info' })
}

function onClose () {
    codeVisible.value = false;
}

// 验证通过后
function onConfirm () {
    onClose();
    if (activeItem.value?.stageJson?.code >= 50) pageJump({ name: 'scientificResearchProjectGroup', query: { id: activeItem.value?.id, name: activeItem.value?.projectName } }, true)
    else pageJump(jumpHref.rating2.matchRatingDetail(activeItem.value?.eventsId, { projectType: activeItem.value?.projectTypeJson?.code }), true)
}


function goSquare () {
    const query = { type: projectType.value }
    pageJump({ name: 'scientificResearchProjectCenter', query }, true)
}
</script>

<style lang="scss" scoped>
.main-wrap {
    gap: 24px;
    display: flex;
    flex-flow: column;
    position: relative;

    .title {
        align-self: center;
    }

    .link {
        position: absolute;
        top: 68px;
        right: 0;
    }

    .project-list {
        :deep {
            .image {
                width: 100%;
                height: 215px;
            }
        }
    }

    .icon {
        font-size: 14px;
    }

    .ellipsis {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
